import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    background: theme.palette.grey[200],
    borderRadius: 8,
    margin: '0px 0px 8px 0px',
    justifyContent: 'center',
    gap: 8
  },
  ballancedetails: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  text: {
    color: theme.palette.text.primary,
    fontWeight: 600
  }
}))
export default useStyles
